import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/move-to-stage.svg.
export const MoveToStageIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function MoveToStageIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 16 16"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <path d="M16 12H11V14H16V12Z" />
        <path d="M16 8H11V10H16V8Z" />
        <path d="M16 4H11V6H16V4Z" />
        <path d="M5 12H9V14H5C2.243 14 0 11.757 0 9C0 6.243 2.243 4 5 4V1L9 5L5 9V6C3.346 6 2 7.346 2 9C2 10.654 3.346 12 5 12Z" />
      </BaseIcon>
    );
  },
);
